<template>
  <div>
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <q-input
          label="Дата начала *"
          :model-value="formData.date_from"
          @update:model-value="(value) => onChange('date_from', value)"
          type="date"
          outlined
          dense
          :rules="[val => !!val || 'Укажите дату начала']"
        />
      </div>
      <div class="form__item">
        <q-input
          label="Дата окончания *"
          :model-value="formData.date_end"
          @update:model-value="(value) => onChange('date_end', value)"
          type="date"
          outlined
          dense
          :rules="[val => !!val || 'Укажите дату окончания']"
        />
      </div>

      <div class="form__item">
        <DocumentUploader
          label="Загрузить файл"
          accept=".pdf,.jpg,.jpeg,.png"
          accepted-formats="PDF, JPG, PNG"
          :allowed-extensions="['.pdf', '.jpg', '.jpeg', '.png']"
          @file-selected="handleFileSelected"
          @file-removed="handleFileRemoved"
          @file-error="handleFileError"
          ref="documentUploader"
        />
      </div>

      <div v-if="fileError" class="form__error">{{ fileError }}</div>

      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import DocumentUploader from '@/components/common/DocumentUploader'
import CustomModalFooter from '@/components/modal/modals/modal-footer'
import { useAppStore } from '@/services/store/app'
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'

export default {
  name: 'add-attorney',
  components: {
    DocumentUploader,
    CustomModalFooter
  },
  props: ['data'],
  setup() {
    const { closeModal } = useAppStore()
    const { showErrorSnackbar, showSucceedSnackbar } = useCustomSnackbar()
    return { closeModal, showErrorSnackbar, showSucceedSnackbar }
  },
  data() {
    return {
      loading: false,
      fileError: '',
      formData: {
        attorney_id: this.data?.data?.attorney_id || null,
        attorney_name: this.data?.data?.attorney_name || '',
        date_from: this.data?.data?.date_from || '',
        date_end: this.data?.data?.date_end || '',
        attorney_file: null
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value ?? ''
      this.fileError = ''
    },
    handleFileSelected(file) {
      this.fileError = ''
      
      // Проверка размера
      if (file.size > 10 * 1024 * 1024) {
        const errorMsg = 'Размер файла не должен превышать 10 МБ'
        this.fileError = errorMsg
        this.$refs.documentUploader?.setError(errorMsg)
        this.$refs.documentUploader?.clearFile()
        this.formData.attorney_file = null
        return
      }

      this.formData.attorney_file = file
      // Устанавливаем название доверенности из имени файла
      this.formData.attorney_name = file.name
    },
    handleFileRemoved() {
      this.formData.attorney_file = null
      // Очищаем название только если это новая доверенность
      // При редактировании сохраняем старое название, если файл не загружен заново
      if (!this.formData.attorney_id) {
        this.formData.attorney_name = ''
      }
      this.fileError = ''
    },
    handleFileError(error) {
      this.fileError = error
    },
    async onSubmit() {
      this.fileError = ''

      if (!this.formData.date_from) {
        this.fileError = 'Укажите дату начала'
        return
      }
      if (!this.formData.date_end) {
        this.fileError = 'Укажите дату окончания'
        return
      }
      if (this.formData.date_from > this.formData.date_end) {
        this.fileError = 'Дата начала не может быть позже даты окончания'
        return
      }

      // Для новой доверенности файл обязателен
      if (!this.formData.attorney_id && !this.formData.attorney_file) {
        this.fileError = 'Загрузите файл доверенности'
        return
      }

      // Если файл загружен, используем его имя как название доверенности
      // Если файл не загружен, но это редактирование - используем старое название из formData
      if (this.formData.attorney_file) {
        this.formData.attorney_name = this.formData.attorney_file.name
      }

      this.loading = true
      
      try {
        await this.data?.onSubmit(this.formData)
        this.showSucceedSnackbar(
          this.formData.attorney_id ? 'Доверенность обновлена' : 'Доверенность добавлена'
        )
        this.closeModal()
      } catch (error) {
        const errorMsg = error?.response?.data?.error || error?.message || 'Ошибка при сохранении доверенности'
        this.showErrorSnackbar(errorMsg)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.form {
  &__item {
    margin-bottom: 20px;
  }

  &__error {
    color: #c10015;
    font-size: 12px;
    margin-bottom: 16px;
  }
}
</style>

